import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import moment from 'moment'
import PropTypes from 'prop-types'
import config from '../../../config'
import { Button, Form, Modal, Popconfirm, Input, Upload, Icon, Select, Spin } from 'antd'

import * as revisionSelectors from '../../../selectors/revision'

import Attachments from './Attachments'

const { Option } = Select
const FormItem = Form.Item
const { TextArea } = Input
const { API_BASE } = config

const propTypes = {
  selectedTesting: PropTypes.object,
  isModalOpen: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  createTesting: PropTypes.func.isRequired,
  updateTesting: PropTypes.func.isRequired,
  deleteTesting: PropTypes.func.isRequired,
  loadingRevision: PropTypes.bool.isRequired,
  revisions: PropTypes.array,
  updateSelectedTesting: PropTypes.func.isRequired,

  getRevision: PropTypes.func.isRequired
}

class AddEditModal extends Component {
  state = {
    fileList: [],
    attachmentDetailsVisible: false,
    attachmentName: null,
    currentRevisionNumberPrint: 1
  }

  componentDidUpdate(prevProps) {
    // update the current version for printing
    if (prevProps.loadingRevision !== this.props.loadingRevision) {
      const { revisions } = this.props
      if (revisions) {
        this.setState({
          currentRevisionNumberPrint: revisions[revisions.length - 1].currentRevisionNumber
        })
      }
    }
  }

  handleCreateEdit = () => {
    const form = this.props.form
    const { createTesting, updateTesting, selectedTesting } = this.props
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const { fileList } = this.state
      const formData = new FormData()
      fileList.forEach(file => {
        formData.append('file', file)
      })
      formData.append('name', values.name)
      formData.append('description', values.description)
      formData.append('category', values.category)

      if (!selectedTesting) {
        createTesting(formData)
      } else {
        updateTesting({
          name: values.name,
          description: values.description,
          category: values.category
        })
      }

      form.resetFields()
    })
  }

  confirmDelete = () => {
    const { deleteTesting, selectedTesting } = this.props
    deleteTesting(selectedTesting.id)
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleEditAttachment = () => {
    const { selectedTesting } = this.props
    this.props.updateAttachmentDescription({
      attachmentId: selectedTesting.id,
      testingId: selectedTesting.id,
      description: this.state.attachmentDescription
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  handleRevisionChange = revisionNumber => {
    const { getRevision, updateSelectedTesting } = this.props
    const revision = getRevision(revisionNumber + 1)
    updateSelectedTesting(revision)
  }

  render() {
    const { selectedTesting, isModalOpen, handleCancel, loadingRevision, revisions } = this.props

    const { fileList, currentRevisionNumberPrint } = this.state

    const { getFieldDecorator } = this.props.form

    const uploadPropsOnCreate = {
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file)
          const newFileList = state.fileList.slice()
          newFileList.splice(index, 1)
          return {
            fileList: newFileList
          }
        })
      },
      beforeUpload: file => {
        this.setState(state => ({
          fileList: [...state.fileList, file]
        }))
        return false
      },
      fileList
    }

    return (
      <Modal
        visible={isModalOpen}
        title="Testing"
        okText={selectedTesting ? 'Save Changes' : 'Create'}
        onCancel={handleCancel}
        onOk={this.handleCreateEdit}
        width={selectedTesting ? '90%' : '40%'}
        maskClosable={false}
      >
        <Form layout="vertical">
          {selectedTesting && (
            <div className="row">
              <div className="col-9">
                <h4>Testing #{selectedTesting.id}</h4>
              </div>
              <div className="col-3 text-right">
                {loadingRevision ? (
                  <Spin size="small" />
                ) : (
                  // prettier-ignore
                  <a
                    href={`${API_BASE}/api/job/testing/print/${selectedTesting.id}?revision=${
                      currentRevisionNumberPrint
                    }`}
                    target="_blank"
                  >
                    <Button icon="printer">Print Testing</Button>
                  </a>
                )}
              </div>
            </div>
          )}
          {selectedTesting && (
            <div>
              <div className="row" style={{ marginBottom: '20px' }}>
                <div className="col-3">
                  Created Date:<br />
                  <strong>{moment(selectedTesting.created_date).format('M/D/YYYY')}</strong>
                </div>
                <div className="col-3">
                  Updated Date:<br />
                  <strong>{moment(selectedTesting.updated_date).format('M/D/YYYY')}</strong>
                </div>
                <div className="col-3">
                  Created By:<br />
                  <strong>{`${selectedTesting.created_by_first_name} ${
                    selectedTesting.created_by_last_name ? selectedTesting.created_by_last_name : ''
                  }`}</strong>
                </div>
                <div className="col-3">
                  Updated by:<br />
                  <strong>{`${selectedTesting.updated_by_first_name} ${
                    selectedTesting.updated_by_last_name ? selectedTesting.updated_by_last_name : ''
                  }`}</strong>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <FormItem label="Revision">
                    {loadingRevision ? (
                      <Spin size="small" />
                    ) : (
                      <Select
                        defaultValue={
                          revisions ? revisions[revisions.length - 1].currentRevisionNumber : null
                        }
                        onChange={this.handleRevisionChange}
                        style={{ width: 120 }}
                      >
                        {revisions &&
                          revisions.map(revision => (
                            <Option
                              key={revision.currentRevisionNumber}
                              value={revision.currentRevisionNumber - 1} // revision index
                            >
                              {revision.currentRevisionNumber}
                            </Option>
                          ))}
                      </Select>
                    )}
                  </FormItem>
                </div>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-md-6">
              <FormItem label="Name">
                {getFieldDecorator('name', {
                  rules: [
                    {
                      required: true,
                      message: 'Must enter a name.'
                    }
                  ],
                  initialValue: selectedTesting ? selectedTesting.name : ''
                })(<Input />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Category">
                {getFieldDecorator('category', {
                  rules: [
                    {
                      required: true,
                      message: 'Must enter a category.'
                    }
                  ],
                  initialValue: selectedTesting ? selectedTesting.category : ''
                })(<Input />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  initialValue: selectedTesting ? selectedTesting.description : ''
                })(
                  <TextArea
                    placeholder="Describe the attachment..."
                    rows={4}
                    initialvalue={selectedTesting ? selectedTesting.description : ''}
                  />
                )}
              </FormItem>
            </div>
          </div>
          {!selectedTesting && (
            <div className="row">
              <div className="col-md-12">
                <div>Testing File</div>
                <br />
                <Upload {...uploadPropsOnCreate} name="file">
                  <Button>
                    <Icon type="upload" /> Select the file
                  </Button>
                </Upload>
              </div>
            </div>
          )}
          <Attachments selectedTesting={selectedTesting} />
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={this.confirmDelete}
            okText="Yes"
            cancelText="No"
          >
            {selectedTesting && <Button type="danger" icon="delete" />}
          </Popconfirm>
        </Form>
      </Modal>
    )
  }
}

const mapStateToProps = (state, props) => ({
  loadingRevision: revisionSelectors.getRevisionsLoading(state, props),
  revisions: revisionSelectors.getRevisions(state, props),
  getRevision: revisionSelectors.revisionByRevisionNumberSelector(state, props)
})
const mapDispatchToProps = (dispatch, props) => ({})

AddEditModal.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(AddEditModal)))



// WEBPACK FOOTER //
// ./src/components/jobs/testing/AddEditModal.js